import { create } from 'zustand';

const useMobileSelectionStore = create((set) => ({
  mobileSelectModeIsActive: false,
  toggleMobileSelectModeIsActive: () => set((state) => ({
    mobileSelectModeIsActive: !state.mobileSelectModeIsActive
  })),
  disableMobileSelectMode: () => set({
    mobileSelectModeIsActive: false
  })
}));

export { useMobileSelectionStore as default };
//# sourceMappingURL=mobileSelection.js.map
